export default __webpack_public_path__ + "static/media/39-min.ea803ccb.png";